import script from "./EmailSvg.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSvg.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__